// extracted by mini-css-extract-plugin
module.exports = {"title":"Logo_title__3czoP","logo":"Logo_logo__2_Bp_"};